import { render, staticRenderFns } from "./vFormCHECKBOXES.vue?vue&type=template&id=8c07179c&"
import script from "./vFormCHECKBOXES.vue?vue&type=script&lang=js&"
export * from "./vFormCHECKBOXES.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports